export default {
    'name': 'arrow-triangle',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M12 9.44444L7 15L17 15L12 9.44444Z\' fill=\'#006CFD\'/>'
}
